/*
 * Market / country resolution — the SINGLE source of truth for India vs USA.
 *
 * Country comes from the user's PROFILE (profileData.country), set at signup.
 * Every country-varying surface (dashboard copy, currency, phone, and the Jobs
 * tab's data source) must derive its behavior from here so the two are never
 * out of sync.
 *
 * Jobs-session note: `market.jobSuffix` ("" for US, "_ind" for India) is the
 * agreed switch for choosing the US vs India job tables / `-ind-v2` endpoints.
 * Read the user's market via `marketFromCountry(profileData.country)` (or the
 * `useMarket()` hook) rather than re-parsing the country string anywhere else.
 */

export const MARKETS = {
  US: {
    country: "US",
    label: "United States",
    flag: "🇺🇸",
    currency: "$",
    currencyCode: "USD",
    callingCode: "+1",
    locale: "en-US",
    jobSuffix: "", // default job tables / endpoints
  },
  IN: {
    country: "IN",
    label: "India",
    flag: "🇮🇳",
    currency: "₹",
    currencyCode: "INR",
    callingCode: "+91",
    locale: "en-IN",
    jobSuffix: "_ind", // India job tables / `-ind-v2` endpoints
  },
};

/* Normalize whatever the profile stored (e.g. "india", "India", "USA",
   "united states", "united states of america", "us", "") to a market.
   Defaults to US. */
export function marketFromCountry(country) {
  const c = String(country || "").trim().toLowerCase();
  if (c === "india" || c === "in" || c === "ind" || c === "bharat") return MARKETS.IN;
  return MARKETS.US;
}

/* Format a numeric salary/amount for a market. Accepts a number or a numeric
   string; returns "" for non-numeric input so callers can guard cleanly. */
export function formatMoney(amount, market) {
  const m = market || MARKETS.US;
  const n = typeof amount === "number" ? amount : Number(String(amount).replace(/[^\d.-]/g, ""));
  if (!Number.isFinite(n)) return "";
  return `${m.currency}${n.toLocaleString(m.locale)}`;
}
